import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@environment';
import { User$ } from '@injectables';
import { combineLatest, op, take } from '@lib/rxjs';

declare global {
	interface Window {
		ZohoDeskAsap: any;
		ZohoDeskAsapReady: (callback:()=>void)=>void;
		ZohoDeskAsap__asyncalls: Array<()=>void>;
		ZohoDeskAsapReadyStatus: boolean;
		ZohoDeskAsapInit: ()=>{};
	}
}

@Injectable({
	providedIn: 'root',
})
export class SupportButtonService implements OnDestroy{
	private isHidden=false;
	private isOpen=false;
	public get initialized(){return !!window.ZohoDeskAsap?.invoke}
	public get visible(){return !this.isHidden}

	constructor(
                public readonly user$: User$,
	){
		// Hiding support button temporarily for other than Strayos vendor
		if(environment.vendor === 'Strayos'){
			this.initializeZohoDeskAsap();
		}
	}
    public readonly userName = this.user$
        .pipe(op.map(user => user?.displayName()));

    public readonly email = this.user$
        .pipe(op.map(user => user?.email));

	ngOnDestroy(): void {
		throw new Error('Method not implemented.');
	}

	private initializeZohoDeskAsap(){
		window.ZohoDeskAsapReady=(callback)=>{
			const asyncCalls=window.ZohoDeskAsap__asyncalls=window.ZohoDeskAsap__asyncalls||[];
			if(window.ZohoDeskAsapReadyStatus){
				if(callback)
					asyncCalls.push(callback);
				
				asyncCalls.forEach((cb)=>{
					if(cb) cb();
				});
				window.ZohoDeskAsap__asyncalls=null;
			}else{
				if(callback)
					asyncCalls.push(callback);
			}
		}

		window.ZohoDeskAsapInit=()=>{
			return {
				hideLauncherIcon: true
			}
		}

		// set up the event listener for forms prefill
		window.ZohoDeskAsapReady(() => {
			window.ZohoDeskAsap.on("onAppOpen", () => {
			  const sourceUrl = window.location.href;
		  
			  combineLatest([this.userName, this.email]).pipe(take(1)).subscribe(([userNameValue, emailValue]) => {
				window.ZohoDeskAsap.set("ticket.form.prefillValues", {
				  [`${environment.zohoDesk.departmentId}&&&${environment.zohoDesk.layoutId}`]: {
					'contactId': {
					  defaultValue: userNameValue
					},
					'email': {
					  defaultValue: emailValue
					},
					'cf_source_url': {
					  defaultValue: sourceUrl,
					  isHidden: true
					}
				  }
				});
		  
				this.isOpen = true;
			  });
			});
		  
			window.ZohoDeskAsap.on("onAppClose", () => {
			  this.isOpen = false;
			});
		  });
		  

		const script=document.createElement('script');
		script.type='text/javascript';
		script.id='zohodeskasapscript';
		script.defer=true;
		script.src=`https://desk.zoho.com/portal/api/web/asapApp/${environment.zohoDesk.widgetId}?orgId=${environment.zohoDesk.orgId}`;

		document.getElementsByTagName('body')[0].appendChild(script);
	}

	public positionRelativeToPoint(x:number, y:number){
		// TODO: Implement this function
	}

	public toggle(){
		window.ZohoDeskAsap?.invoke(this.isOpen?'close':'open');
	}

	public openTicketForm(){
		if(this.isOpen){
			window.ZohoDeskAsap?.invoke("close");
		}else{
			window.ZohoDeskAsap?.invoke("routeTo",{ 
				page:"ticket.form", 
				parameters:{ 
					departmentId:environment.zohoDesk.departmentId, 
					layoutId:environment.zohoDesk.layoutId, 
				}
			});
		}
	}

	public hide(){
		this.isHidden=true;
	}

	public show(){
		this.isHidden=false;
	}
}
